module.exports = __webpack_public_path__ + "img/logo-orange-yellow-mobile.71044f8d.svg";